import { render, staticRenderFns } from "./StandardEmbroideryList.vue?vue&type=template&id=49e11b21&scoped=true&"
import script from "./StandardEmbroideryList.vue?vue&type=script&lang=js&"
export * from "./StandardEmbroideryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e11b21",
  null
  
)

export default component.exports